import { render, staticRenderFns } from "./ApCreate.vue?vue&type=template&id=4167af68&scoped=true&"
import script from "./ApCreate.vue?vue&type=script&lang=js&"
export * from "./ApCreate.vue?vue&type=script&lang=js&"
import style0 from "./ApCreate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ApCreate.vue?vue&type=style&index=1&id=4167af68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4167af68",
  null
  
)

component.options.__file = "ApCreate.vue"
export default component.exports